import { useNavigator } from '@repo/toolkit/use-navigator'
import { Column } from '@repo/ui/data-table'
import { BankIcon, PlusIcon } from '@repo/ui/icons'
import React, { useState } from 'react'

import { API } from '../../api/apis.config'
import FilterDrawer from '../../components/elements/drawers/filter-drawer'
import DynamicDataTable, { DynamicTableRef } from '../../components/elements/dynamic-table'
import { countFilters } from '../../components/elements/dynamic-table/utils/countFilters'
import UserNavBar from '../../components/elements/nav-bar'
import { Paths } from '../../lib/constants/path'
import { useFilters } from '../../lib/hooks/use-filters'
import { useModalManager } from '../../lib/hooks/use-modal-manager'
import {
  LecBankAccount,
  LecBankAccountFilters
} from '../../lib/types/models/lec-bank-account/lec-bank-account'
import {
  transformLecBankAccountFiltersToUrl,
  transformUrlToLecBankAccountFilters
} from '../../lib/utils/filters-mapping/lec-bank-account'
import LecBankAccountFilter from './lec-bank-account-filter'

export const lecBankAccountInitialFilters: LecBankAccountFilters = {}

const LecBankAccountListPage = () => {
  const { navigate, navigateWithEvent } = useNavigator()
  const [isTableLoading, setIsTableLoading] = useState(false)

  const { selectedFilter, filter, onFilterChange, resetFilters, onSelectedFilterChange } =
    useFilters<LecBankAccountFilters>({
      initialFilters: lecBankAccountInitialFilters,
      options: { allowSearchParam: true },
      transformFilterToUrl: transformLecBankAccountFiltersToUrl,
      transformUrlToFilter: transformUrlToLecBankAccountFilters
    })

  const { modalState, toggleModal, closeModel } = useModalManager<'filters'>(['filters'])
  const tableRef = React.useRef<DynamicTableRef<LecBankAccount>>(null)

  const columns: Column<LecBankAccount>[] = [
    {
      accessorKey: 'accountHolder',
      header: 'Titulaire du compte'
    },
    {
      accessorKey: 'bankName',
      header: 'Nom de la banque'
    },
    {
      accessorKey: 'iban',
      header: 'IBAN'
    },
    {
      accessorKey: 'currency',
      header: 'Devise'
    }
  ]

  return (
    <div>
      <UserNavBar title="Comptes bancaires de LEC" icon={BankIcon} />
      <div className={'h-4'} />

      <DynamicDataTable<LecBankAccount, LecBankAccountFilters>
        ref={tableRef}
        onLoadingChange={setIsTableLoading}
        title="Tous les comptes bancaires LEC"
        displayOrder
        deleteMessage="Etes-vous sûr de vouloir supprimer ce compte bancaire ?"
        columns={columns}
        selectable
        allowSearchParam
        endpoint={API.lecBankAccounts.getAll.url}
        onFiltersClick={() => toggleModal('filters')}
        filters={selectedFilter}
        filtersLength={countFilters(selectedFilter)}
        onRowClick={(account, event) =>
          navigateWithEvent(
            Paths.LEC_BANK_ACCOUNTS_UPDATE_PAGE.replace(':id', account.id.toString()),
            event
          )
        }
        actions={[
          {
            type: 'global',
            icon: PlusIcon,
            refetch: true,
            variant: 'primary',
            label: 'Créer un nouveau compte bancaire LEC',
            fn: () => navigate(Paths.LEC_BANK_ACCOUNTS_CREATE_PAGE)
          }
        ]}
      />

      <FilterDrawer
        isOpen={modalState.filters}
        selectedFilter={selectedFilter}
        isLoading={isTableLoading}
        onClose={() => closeModel('filters')}
        onReset={resetFilters}
        onApply={() => onSelectedFilterChange({ ...filter })}
        onFilterChange={onFilterChange}
      >
        <LecBankAccountFilter filter={filter} onFilterChange={onFilterChange} />
      </FilterDrawer>
    </div>
  )
}

export default LecBankAccountListPage
